// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const EntityViewSwitchRoot = styled.div`
  padding: 0.25rem 0;
`;
